import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
//import Table from "./Table";
import axios from "axios";
import Table from "./LeaseListingTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPen,
  faPlus,
  faSave,
  faTimes,
  faUndo,
  faFileExcel,
  faEye,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
//import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
//import styles from "../../masters/master.css";
import apiUrl from "../../apiUrlConstant";
//import CreatableSelect from "react-select/creatable";
import { Redirect, withRouter, Link } from "react-router-dom";
//import Select from "react-select";

import styled from "styled-components";
import Select, {
  components,
  MultiValueGenericProps,
  MultiValueProps,
  OnChangeValue,
  Props,
} from "react-select";

import * as Yup from "yup";
import { type } from "jquery";
import { getUserType } from "../../utils/index";

if (getUserType() == "Landlord") {
  var reportFilterForm = Yup.object().shape({
    assetId: Yup.string().required("Required"),
    leaseId: Yup.number().required("Required"),
    financialYear: Yup.string().required("Required"),
    dataUomId: Yup.string().required("Required"),
    //stateId: Yup.string().required("Required"),
    //districtId: Yup.string().required("Required"),
    //cityId: Yup.string().required("Required"),
  });
} else if (getUserType() == "Occupier") {
  var reportFilterForm = Yup.object().shape({
    brandId: Yup.number().required("Required"),
    leaseId: Yup.number().required("Required"),
    financialYear: Yup.string().required("Required"),
    dataUomId: Yup.string().required("Required"),
    // stateId: Yup.string().required("Required"),
    // districtId: Yup.string().required("Required"),
    // cityId: Yup.string().required("Required"),
  });
} else {
  var reportFilterForm = Yup.object().shape({
    leaseId: Yup.number().required("Required"),
    financialYear: Yup.string().required("Required"),
    dataUomId: Yup.string().required("Required"),
  });
}

// const reportFilterForm = Yup.object().shape({
//   countryId: Yup.string().required("Required"),
//   stateId: Yup.string().required("Required"),
//   districtId: Yup.string().required("Required"),
//   cityId: Yup.string().required("Required"),
//   leaseId: Yup.array().required("Required"),
//   financialYear: Yup.string().required("Required"),
//   dataUomId: Yup.string().required("Required"),
// });

const ClearButton = styled.button`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  columns={columns}
  height: 34px;
  width: 32px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color:#003970;
`;
//const [selectedValue, setSelectedValue] = useState([]);

let monthsArr = [];
var i = 0;
for (; i <= 12; i++) {
  monthsArr.push({ id: i, value: i });
}

let financialYear = [];
// var i = 0;  let currentYear = new Date().getFullYear();
// financialYear.push({ id: (currentYear + 1) , value: (currentYear )  + "-" + (currentYear + 1) })
// for (; i <= 10; i++) {
//   financialYear.push({ id: currentYear , value: (currentYear - 1)  + "-" + currentYear });
//   --currentYear;
// }

var tableCounter = 0;

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

class LeaseReportSalesView extends React.Component {
  groupId = { value: "" };
  state = {
    brandSelected: [],
    exportUrl: "",
    selectedValue: [],
    setSelectedValue: [],
    leaseSelected: [],
    countries: [],
    districtList: [],
    cityList: [],
    brandCatList: [],
    brandList: [],
    financialYear: [],
    assetsList: [],
    redirect: false,
    states: [],

    id: undefined,
    selectedBrand: "",
    counter: 0,
    selectedAsset: "",

    leaseList: [],
    formResponseData: [],
    tableColumns: [],
    formResponseData1: {
      forecasteDetails: {
        forecast: [],
        actual: [],
      },
    },
    initialForecast: {},
    initialValues: {
      brandId: [],
      countryId: "",
      stateId: "",
      districtId: "",
      cityId: "",
      brandCatId: "",
      brandName: [],
      leaseId: "",
      financialYear: "",
      dataUomId: "Per Month",
      dataUOMName: "Per Month",
    },
  };

  componentDidMount() {
    fetch(`${apiUrl.apiUrl.url}/countries`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          countries: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/brand/get-brand-category`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          brandCatList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/lease-report/get-lease-status`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("data", data);
        this.setState({
          leaseStatus: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    this.getAssetsList("", "", true);
  }

  componentDidUpdate() { }

  constructor(props) {
    super(props);
  }

  getAssetsList = (input, e, cust) => {
    if (
      (typeof e != "undefined" && e.action == "input-change") ||
      cust === true
    ) {
      fetch(
        `${apiUrl.apiUrl.url}/unit-detail/get-all-assets?city_id=` +
        this.state.initialValues.cityId +
        `&assetName=` +
        input,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log("data", data);
          this.setState({
            assetsList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  setMasterPreValues = (input) => {
    fetch(
      `${apiUrl.apiUrl.url}/unit-detail/get-select-asset-details?assetId=` +
      input,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          countries: data.countries,
          districtList: data.district,
          states: data.state,
          cityList: data.cities,
        });
        this.state.initialValues.stateId = data.data.stateId.stateId;
        this.state.initialValues.state_name = data.data.stateId.state_name;
        this.state.initialValues.cityId = data.data.cityId.cityId;
        this.state.initialValues.cityName = data.data.cityId.cityName;
        this.state.initialValues.districtId = data.data.districtId.districtId;
        this.state.initialValues.districtName =
          data.data.districtId.districtName;
        this.state.initialValues.countryId = data.data.countryId.countryId;
        this.state.initialValues.countryName = data.data.countryId.countryName;
        if (
          this.state.initialValues.brandId.length == 0 ||
          this.state.initialValues.brandId == ""
        ) {
          this.state.initialValues.brandCatId = data.data.catId;
          this.state.initialValues.brandCatName = data.data.cat_name;
          this.state.brandList = data.brandList;
          this.state.brandSelected = [
            { value: data.data.brandId, label: data.data.brand_name },
          ];
          this.state.initialValues.brandId = [data.data.brandId];
        }
        this.setState({});
      })
      .catch((error) => {
        console.log(error);
      });
  };

  valueChange = (newValue, actionMeta) => {
    console.log("newVa calling..", newValue, "meta", actionMeta);

    //newValue.value = newValue.target.value;
    //newValue.label = newValue.target.value;

    if (actionMeta == "change_state") {
      this.state.initialValues.stateId = newValue.value;
      this.state.initialValues.state_name = newValue.label;

      this.state.initialValues.districtId = "";
      this.state.initialValues.districtName = "";
      this.state.initialValues.cityId = "";
      this.state.initialValues.cityName = "";

      this.state.initialValues.assetId = "";
      this.state.initialValues.assetName = "";

      fetch(
        `${apiUrl.apiUrl.url}/district/state-districts?state_id=` +
        newValue.value, {headers}
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            districtList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });

      //districtList
    } else if (actionMeta == "change_district") {
      this.state.initialValues.districtId = newValue.value;
      this.state.initialValues.districtName = newValue.label;

      this.state.initialValues.cityId = "";
      this.state.initialValues.cityName = "";

      fetch(`${apiUrl.apiUrl.url}/cities/district-cities/` + newValue.value, {headers})
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            cityList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (actionMeta == "change_lease_number") {
      //change_document_type
      this.state.initialValues.leaseId = [];
      this.state.leaseSelected = [];

      if (newValue[0].value == 0) {
        this.state.leaseSelected.push({
          value: newValue[0].value,
          label: newValue[0].label,
        });

        for (let i = 0; i < this.state.leaseList.length; i++) {
          if (this.state.leaseList[i].id != 0) {
            this.state.initialValues.leaseId.push(this.state.leaseList[i].id);
          }
        }
      } else {
        for (let i = 0; i < newValue.length; i++) {
          this.state.initialValues.leaseId.push(newValue[i].value);
          this.state.leaseSelected.push({
            value: newValue[i].value,
            label: newValue[i].label,
          });
        }
      }

      fetch(
        `${apiUrl.apiUrl.url}/lease-view/get-lease-financial-years?leaseId=` +
        this.state.initialValues.leaseId, {headers}
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            financialYear: data.fianancialYears,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (actionMeta == "brand_category") {
      this.state.initialValues.brandCatId = newValue.value;
      this.state.initialValues.brandCatName = newValue.label;
      this.state.initialValues.brandId = [];
      this.state.initialValues.brandName = [];
      //get-brand-subcategory/?id=
      fetch(
        `${apiUrl.apiUrl.url}/brand/get-brand-by-category?cat_id=` +
        newValue.value,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            brandList: data,
          });

          this.state.brandSelected = [];
          this.state.initialValues.brandId = ["0"];
          this.state.brandSelected.push({ value: 0, label: "All" });

          for (let i = 0; i < data.length; i++) {
            this.state.initialValues.brandId.push(data[i].id);
          }

          console.log(
            this.state.initialValues.brandId,
            "this.state.initialValues.brandId"
          );
          this.setState({});

          this.getAssetsListByBrand();
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (actionMeta == "change_city") {
      //brandName
      this.state.initialValues.cityId = newValue.value;
      this.state.initialValues.cityName = newValue.label;

      fetch(
        `${apiUrl.apiUrl.url}/unit-detail/get-all-assets?city_id=` +
        newValue.value,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log("data", data);
          this.setState({
            assetsList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (actionMeta == "change_lease_status") {
      //brandName
      this.state.initialValues.LeaseStatusId = newValue.value;
      this.state.initialValues.LeaseStatusName = newValue.label;
    } else if (actionMeta == "change_brand") {
      //brandName
      this.state.brandSelected = [];
      this.state.initialValues.brandId = [];
      for (let i = 0; i < newValue.length; i++) {
        this.state.initialValues.brandId.push(newValue[i].value);
        this.state.brandSelected.push({
          value: newValue[i].value,
          label: newValue[i].label,
        });
      }

      this.getAssetsListByBrand();

      fetch(
        `${apiUrl.apiUrl.url}/lease-view/get-lease-list?all=true&brand=` +
        this.state.initialValues.brandId +
        "&asset=" +
        this.state.initialValues.assetId +
        "&brandCategory=" +
        this.state.initialValues.brandCatId,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            leaseList: data,
          });

          this.state.initialValues.leaseValue = [];
          this.state.initialValues.leaseId = [];
        })
        .catch((error) => {
          console.log(error);
        });

      console.log(this.state.initialValues, "this.state.initialValues");
    } else if (actionMeta == "change_asset_name") {
      //change_lease_month
      this.state.initialValues.assetId = newValue.value;
      this.state.initialValues.assetName = newValue.label;
      this.setMasterPreValues(newValue.value);
      fetch(
        `${apiUrl.apiUrl.url}/lease-view/get-lease-list?brand=` +
        this.state.initialValues.brandId +
        "&asset=" +
        this.state.initialValues.assetId +
        "&brandCategory=" +
        this.state.initialValues.brandCatId,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            leaseList: data,
          });

          this.state.initialValues.leaseValue = [];
          this.state.initialValues.leaseId = [];
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (actionMeta == "change_uom") {
      //change_lease_month
      this.state.initialValues.dataUomId = newValue.value;
      this.state.initialValues.dataUOMName = newValue.label;

      console.log(this.state.initialValues, "initial valuyes");
    } else if (actionMeta == "change_financial_year") {
      //change_lease_month
      this.state.initialValues.financialYearId = newValue.value;
      this.state.initialValues.financialYear = newValue.label;
    } else if (actionMeta == "change_lease_month") {
      //change_lease_month
      this.state.initialValues.leaseMonthId = newValue.value;
      this.state.initialValues.leaseMonthId = newValue.label;
    } else {
      this.state.initialValues.countryId = newValue.value;
      this.state.initialValues.countryName = newValue.label;
    }
    this.setState({});
  };
  getAssetsListByBrand = () => {
    var headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("TOKEN"),
    };

    fetch(
      `${apiUrl.apiUrl.url}/unit-detail/get-brand-asset-list?brandId=` +
      this.state.initialValues.brandId,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("data", data);
        this.setState({
          assetsList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(
      `${apiUrl.apiUrl.url}/lease-view/get-lease-list?all=true&brand=` +
      this.state.initialValues.brandId +
      "&asset=" +
      this.state.initialValues.assetId +
      "&brandCategory=" +
      this.state.initialValues.brandCatId,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          leaseList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  handleChangeCountry = (newValue, actionMeta) => {
    console.log(newValue.value, "jj");
    this.countryId = newValue.value;
    newValue.label = newValue.label;

    if (newValue.value == "") {
      console.log("country value empty");
      this.state.states = [];
    }

    this.state.initialValues.countryId = newValue.value;
    this.state.initialValues.countryName = newValue.label;

    this.state.initialValues.stateId = "";
    this.state.initialValues.stateName = "";
    this.state.initialValues.districtId = "";
    this.state.initialValues.districtName = "";
    this.state.initialValues.cityId = "";
    this.state.initialValues.cityName = "";

    fetch(`${apiUrl.apiUrl.url}/states/country-states/` + this.countryId, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          states: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleChangeClientGroup = (newValue, actionMeta) => {
    console.group("Value Changed", newValue, "actionmeta", actionMeta);
    this.state.initialValues.groupId = newValue.value;
    this.state.initialValues.groupName = newValue.label;
    this.setState({});
    console.log(newValue, "ddd");
    console.log(`action: ${actionMeta}`);
    console.groupEnd();
  };
  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to="/masters/client-profile" />;
    }
    return (
      <div className="parentContainer">
        {this.renderForm()}
      </div>
    );
  }

  renderForm() {
    return (
      <div>
        <div className="absoluteItemForTopBar">
          <div className="new_breadcrumbs_design">
            <ul className="d-flex align-items-center gap-3 p-0 m-0">
              <li>Reports</li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <a href="#">Sale View - Lease</a>
              </li>
            </ul>
          </div>
        </div>


        <Formik
          initialValues={this.state.initialValues}
          enableReinitialize
          validationSchema={reportFilterForm}
          onReset={(values, actions) => {
            this.state.brandSelected = [];
            this.state.leaseSelected = [];
            for (const [key, value] of Object.entries(
              this.state.initialValues
            )) {
              this.state.initialValues[key] = "";
            }
            this.state.formResponseData = [];
            this.setState({});
          }}
          onSubmit={(values, actions) => {
            values.groupId = this.state.initialValues.groupId;

            var brand_id = this.state.initialValues.brandId;
            var asset_id = this.state.initialValues.assetId;
            var form_config = this.state.initialValues;

            form_config.expiry_status = true;

            var counter = this.state.counter + 1;
            //form_config['export'] = 'true';
            console.log(counter, "counter", form_config);
            this.setState({ counter: counter });

            this.setState({ selectedBrand: brand_id });
            this.setState({ selectedAsset: asset_id });
            this.setState({ formConfig: form_config });
            var prm = Object.entries(form_config)
              .map(([key, val]) => `${key}=${val}`)
              .join("&");
            this.state.formResponseData = [];
            //FetchSalesDetailView
            fetch(`${apiUrl.apiUrl.url}/sales-input/fetch-sales-detail-view?` + prm, {headers})
              .then((response) => {
                return response.json();
              })
              .then((data) => {
                //this.setState({  });
                tableCounter = 0;

                console.log(data, "datata");

                this.setState({
                  formResponseData: data.data,
                  tableColumns: data.columns,
                  colKeys: data.col_keys,
                  //initialForecast:data.forecasteDetails
                });

                //var prm = Object.entries(form_config).map(([key, val]) => `${key}=${val}`).join('&');
                //this.state.exportUrl = `${apiUrl.apiUrl.url}/sales-input/fetch-sales-view?export=true&` + prm;

                this.setState({
                  exportUrl:
                    `${apiUrl.apiUrl.url}/sales-input/fetch-sales-detail-view?export=true&` +
                    prm,
                });

                //this.state.initialForecast.year =   data.year
              })
              .catch((error) => {
                console.log(error);
              });

            form_config = undefined;
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
          }) => (
            <div className="unitFormContainerNew">
              <Form autoComplete="off">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Country
                          </label>
                          <div className="col-sm-7">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              name="countryId"
                              isSearchable="true"
                              onChange={(e) => {
                                this.handleChangeCountry(e, "changecountry");
                              }}
                              value={{
                                label: this.state.initialValues.countryName,
                                value: this.state.initialValues.countryId,
                              }}
                              options={this.state.countries.map((item) => ({
                                label: item.country_name,
                                value: item.id,
                              }))}
                            />

                            <ErrorMessage
                              name="countryId"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Brand Category
                          </label>
                          <div className="col-sm-7">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              name="brandCatId"
                              // onInputChange={this.handleChange}
                              // onChange={}
                              onChange={(e) => {
                                //handleChange(e);
                                this.valueChange(e, "brand_category");
                              }}
                              value={{
                                label: this.state.initialValues.brandCatName,
                                value: this.state.initialValues.brandCatId,
                              }}
                              options={this.state.brandCatList.map((item) => ({
                                label: item.category_name,
                                value: item.id,
                              }))}
                            />

                            <ErrorMessage
                              name="brandCatId"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            State
                          </label>
                          <div className="col-sm-7">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              name="stateId"
                              // onInputChange={this.handleChange}
                              // onChange={}
                              onChange={(e) => {
                                //handleChange(e);
                                this.valueChange(e, "change_state");
                              }}
                              value={{
                                label: this.state.initialValues.state_name,
                                value: this.state.initialValues.state_id,
                              }}
                              options={this.state.states.map((item) => ({
                                label: item.state_name,
                                value: item.id,
                              }))}
                            />

                            <ErrorMessage
                              name="stateId"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Brand Name
                          </label>
                          <div className="col-sm-7">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              name="brandId"
                              isMulti
                              //closeMenuOnSelect={false}
                              onInputChange={this.handleChange}
                              // onChange={}
                              onChange={(e) => {
                                //handleChange(e);
                                this.valueChange(e, "change_brand");
                              }}
                              value={this.state.brandSelected}
                              options={this.state.brandList.map((item) => ({
                                label: item.brand_name,
                                value: item.id,
                              }))}
                            />

                            <ErrorMessage
                              name="brandId"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            District
                          </label>
                          <div className="col-sm-7">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              name="districtId"
                              // onInputChange={this.handleChange}
                              // onChange={}
                              onChange={(e) => {
                                //handleChange(e);
                                this.valueChange(e, "change_district");
                              }}
                              value={{
                                label: this.state.initialValues.districtName,
                                value: this.state.initialValues.districtId,
                              }}
                              options={this.state.districtList.map((item) => ({
                                label: item.district_name,
                                value: item.id,
                              }))}
                            />

                            <ErrorMessage
                              name="districtId"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Lease Number
                          </label>
                          <div className="col-sm-7">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              name="leaseId"
                              isMulti
                              onInputChange={this.handleChange}
                              onChange={(e) => {
                                this.valueChange(e, "change_lease_number");
                              }}
                              value={this.state.leaseSelected}
                              // value={{
                              //   label: this.state.initialValues.leaseValue,
                              //   value: this.state.initialValues.leaseId,
                              // }}
                              options={this.state.leaseList.map((item) => ({
                                label: item.lease_code,
                                value: item.id,
                              }))}
                            />

                            <ErrorMessage
                              name="leaseId"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            City
                          </label>
                          <div className="col-sm-7">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              name="cityId"
                              // onInputChange={this.handleChange}
                              // onChange={}
                              onChange={(e) => {
                                //handleChange(e);
                                this.valueChange(e, "change_city");
                              }}
                              value={{
                                label: this.state.initialValues.cityName,
                                value: this.state.initialValues.cityId,
                              }}
                              options={this.state.cityList.map((item) => ({
                                label: item.city_name,
                                value: item.id,
                              }))}
                            />

                            <ErrorMessage
                              name="cityId"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Data UOM <span className="astrik">*</span>
                          </label>
                          <div className="col-sm-7">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              onChange={(e) => {
                                this.valueChange(e, "change_uom");
                              }}
                              value={{
                                label: this.state.initialValues.dataUOMName,
                                value: this.state.initialValues.dataUOMId,
                              }}
                              name="dataUomId"
                              options={["Per Month"].map((item) => ({
                                label: item,
                                value: item,
                              }))}
                            />

                            <ErrorMessage
                              name="dataUomId"
                              component="div"
                              className="text-red"
                            />
                            {/* <option value="" label="Select" defaultValue />
                              <option value="Per Month" label="Per Month" />
                            </Field> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Asset Name
                          </label>
                          <div className="col-sm-7">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              name="assetId"
                              onInputChange={this.getAssetsList}
                              // onInputChange={this.handleChange}
                              // onChange={}
                              onChange={(e) => {
                                //handleChange(e);
                                this.valueChange(e, "change_asset_name");
                              }}
                              value={{
                                label: this.state.initialValues.assetName,
                                value: this.state.initialValues.assetId,
                              }}
                              options={this.state.assetsList.map((item) => ({
                                label: item.asset_name,
                                value: item.id,
                              }))}
                            />

                            <ErrorMessage
                              name="assetId"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Financial Year Ending On{" "}
                            <span className="astrik">*</span>
                          </label>
                          <div className="col-sm-7">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              name="financialYear"
                              // onInputChange={this.handleChange}
                              // onChange={}
                              onChange={(e) => {
                                //handleChange(e);
                                this.valueChange(e, "change_financial_year");
                              }}
                              value={{
                                label: this.state.initialValues.financialYear,
                                value: this.state.initialValues.financialYear,
                              }}
                              options={this.state.financialYear.map((item) => ({
                                label: item.value,
                                value: item.id,
                              }))}
                            />

                            <ErrorMessage
                              name="financialYear"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-6 offset-lg-6">
                      <div className="btnContainer">
                        <div>
                          <button type="submit">
                            View
                          </button>
                          <button type="reset" d1isabled={isSubmitting}>
                            Reset
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          )}
        </Formik>

        <div className="unitFormContainer unitFormContainerTable">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                {this.state.formResponseData.length > 0 && (
                  <a href={this.state.exportUrl}>
                    <ClearButton type="button" onClick={this.state.exportUrl}>
                      <FontAwesomeIcon icon={faFileExcel} />
                    </ClearButton>
                  </a>
                )}

                <div className="tableContainer reportsTable" style={{ "overflow": "auto" }} >
                  <table className="table tableSimple">
                    <thead>
                      <tr>
                        {this.state.formResponseData.length > 0 &&
                          this.state.tableColumns.map((i, v) => {
                            return (
                              <th rowSpan="2">{i}</th>
                            );
                          })
                        }
                      </tr>

                    </thead>
                    <tbody>

                      {this.state.formResponseData.length > 0 && this.state.formResponseData.map((i, v) => {
                        return (
                          <tr>
                            <td >{i['sr_no']}</td>
                            <td >{i['assetName']}</td>
                            <td >{i['brandName']}</td>
                            <td >{i['leaseName']}</td>
                            <td >{i['grossLeasebleArea']}</td>
                            <td >{i['type']}</td>
                            <td >{i['fy']}</td>
                            <td >{i['Apr'] || 0}</td>
                            <td >{i['May'] || 0}</td>
                            <td >{i['Jun'] || 0}</td>
                            <td >{i['Jul'] || 0}</td>
                            <td >{i['Aug'] || 0}</td>
                            <td >{i['Sep'] || 0}</td>
                            <td >{i['Oct'] || 0}</td>
                            <td >{i['Nov'] || 0}</td>
                            <td >{i['Dec'] || 0}</td>
                            <td >{i['Jan'] || 0}</td>
                            <td >{i['Feb'] || 0}</td>
                            <td >{i['Mar'] || 0}</td>
                            <td >{i['total'] || 0}</td>
                          </tr>
                        );
                      }
                      )}

                      {this.state.formResponseData.length == 0 && (
                        <tr>
                          <td colSpan="12" className="text-center"> Nothing to show.....</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(LeaseReportSalesView);
